ScoreTrekBattle.Club = (function() {
    var _this, STATUS;

    STATUS = {
        club: null
    };

    _this = {
        setCurrent: function(club) {
            STATUS.club = club;
        },

        getCurrent: function() {
            return STATUS.club;
        },

        getCurrentName: function(clubId) {
            var hasClub;

            hasClub = STATUS.club && (!clubId || (STATUS.club.id === clubId));

            return hasClub ? STATUS.club.official_name : __i18n('share/name/club');
        },

        getShareHash: function(clubId, shareType) {
            if (shareType === 'clubSeries') {
                return `/club/series/${clubId}`;
            }

            if (shareType === 'clubMatchdays') {
                return ScoreTrekBattle.League.ClubMatchdays.getShareHash() || `/club/matchdays/${clubId}`;
            }

            return `/club/${clubId}`;
        },

        getMapsUrl: function(club) {
            if (!club) {
                return 'javascript:'
            }
            return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(`${club.street} ${club.number}, ${club.zip} ${club.city}`)}`;
        },

        load: function(clubId) {
            return new Promise(function(resolve, reject) {
                Api.request('/battle/club/load', {
                    clubId: clubId
                }).then(result => {
                    if (!result || !result.club) {
                        reject(new Error('CLUB_DOES_NOT_EXIST'));
                    }
                    resolve(result.club);
                }).catch(reject);
            });
        },

        escape: function(club) {
            return {
                email: __escapeHTML(club.email),
                phone: __escapeHTML(club.phone || ''),
                phoneNormalized: __escapeHTML(club.phoneNormalized || ''),
                website: __escapeHTML(club.website || '')
            };
        }
    };

    addEventListener("DOMContentLoaded", () => {
        ScoreTrekBattle.View.register(
            '/club/friends',
            () => {
                return new Promise(function(resolve) {
                    ScoreTrekBattle.Template.render('club/friends', {
                    }).then(view => {
                        resolve(view.$view);
                    });
                });
            },
            () => {
                return new Promise(function(resolve) {
                    resolve();
                });
            },
            () => {
                return new Promise(function(resolve) {
                    resolve();
                });
            },
            () => {
                return new Promise(function(resolve) {
                    resolve();
                });
            }
        );
    });


    return _this;
})();
